import { render, staticRenderFns } from "./HubOnboarding.vue?vue&type=template&id=10f6b1ee&scoped=true&"
import script from "./HubOnboarding.vue?vue&type=script&lang=js&"
export * from "./HubOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./HubOnboarding.vue?vue&type=style&index=0&id=10f6b1ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6b1ee",
  null
  
)

export default component.exports